"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _default(theme, props) {
  var vertical = props.vertical,
      divider = _objectSpread({}, theme.divider),
      number = theme.number;

  return {
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      flexDirection: vertical ? 'column' : 'row'
    },
    dividerWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: divider.padding,
      height: vertical ? 'auto' : number.height,
      width: vertical ? number.width : 'auto',
      boxSizing: 'border-box'
    },
    divider: {
      background: divider.background,
      height: vertical ? divider.width : divider.height,
      width: vertical ? divider.height : divider.width
    }
  };
}